import { AchievementBEData, ImportedAchievement } from "types/achievements";
import { array, object, string } from "yup";

const achievementSchema = object({
  translations: object().required(),
  rules: array(
    object({
      trigger: string().oneOf(["transaction", "custom_event"]),
      type: string().oneOf(["direct", "referral"]),
    }),
  ).required(),
  aggregation: object({
    type: string().oneOf(["quantity", "expression"]),
  }).required(),
  completeRule: object({
    period: object({
      type: string().oneOf([
        "day",
        "week",
        "month",
        "year",
        "overall",
        "last_day",
      ]),
    }).required(),
    periodGoal: string(),
  }),
});

export const isAchievementJsonValid = (achievement: AchievementBEData) => {
  try {
    achievementSchema.validateSync(achievement);

    return true;
  } catch {
    return false;
  }
};

export const getCurrentName = (
  translations: {
    [key: string]: {
      description?: string;
      name: string;
    };
  },
  isoCode: string,
) => translations[isoCode].name;

export const formatImportedAchievements = (
  achievements: ImportedAchievement[],
) =>
  achievements.map((achievement) => {
    const transformedRules = achievement.rules.map(
      ({ achievementRuleId, ...rest }) => ({
        ...rest,
      }),
    );
    return {
      name: achievement.name,
      achievementId: achievement.achievementId,
      active: achievement.active,
      activity: achievement.activity,
      limit: achievement.limit,
      translations: achievement.translations,
      rules: transformedRules,
    };
  });
